const seekGradient = (pos) => `linear-gradient(to right, #10afe4 0%, #10afe4 ${pos}%, rgba(0,0,0,0) ${pos}%, rgba(0,0,0,0) 100%)`;

//document.addEventListener('DOMContentLoaded', function() {
    // Attach listener to a stable parent element (like document or a container)
    document.addEventListener('click', function(event) {
        // Check if the clicked element matches your dynamic element
        if (event.target.matches('.audioPlayerButton')||event.target.matches('.audioPlayerButton img')) {
            event.preventDefault();
            const playButton = (event.target.tagName=="IMG")?event.target:event.target.querySelector("img:not([display=none])");
            const audio = playButton.parentNode.parentNode.querySelector(".audioPlayerAudio");
            audio.ontimeupdate ??= () => {
                const progressBar = audio.parentNode.querySelector('.audioPlayerProgressBar');
                const seekBar = progressBar.querySelector("#seek-bar");
                const seekCircle = progressBar.querySelector("#seek-circle");
                const percentComplete = audio.currentTime/audio.duration * 100;
                seekCircle.style.left = `calc(${percentComplete}% - 9px)`;
                seekBar.style["background"] = seekGradient(percentComplete);
            }
            if (audio.paused) {
                audio.play();
                //playButton.src = "{{ 'pause.svg' | asset_url }}";
                playButton.parentNode.querySelector("#play").style.display = "none";
                playButton.parentNode.querySelector("#pause").style.display = "";

            } else {
                audio.pause();
                //playButton.src = "{{ 'play.svg' | asset_url }}";
                playButton.parentNode.querySelector("#pause").style.display = "none";
                playButton.parentNode.querySelector("#play").style.display = "";
            }
        }
    });

    document.addEventListener('loadedmetadata', (event) => {
        //timeDisplay.setDuration(audio().duration);
    });
//});

document.addEventListener('mousedown', (event) => {
    //console.log(event.target);
    if(!event.target.matches("#seek-circle"))
        return;
    const seekCircle = event.target;
    const progressBar = seekCircle.parentNode;
    const audio = progressBar.parentNode.querySelector(".audioPlayerAudio");

    audio.ontimeupdate ??= () => {
        const progressBar = audio.parentNode.querySelector('.audioPlayerProgressBar');
        const seekBar = progressBar.querySelector("#seek-bar");
        const seekCircle = progressBar.querySelector("#seek-circle");
        const percentComplete = audio.currentTime/audio.duration * 100;
        seekCircle.style.left = `calc(${percentComplete}% - 9px)`;
        seekBar.style["background"] = seekGradient(percentComplete);
    }

    //audio.currentTime = seekBar.value;
    //console.log(progressBar.dragging);
    if(progressBar.dragging == undefined) {
        window.addEventListener('mouseup', () => {
            if(!progressBar.dragging)
            return;
            progressBar.dragging = false;
        });

        window.addEventListener('mousemove', (e) => {
            if(!progressBar.dragging)
            return;
            e.preventDefault();
            //console.log(e);
            audio.currentTime = progressBar.dragStartValue + (e.clientX - progressBar.dragStartX)*(audio.duration/progressBar.clientWidth);
        });
    }
    progressBar.dragging = true;
    progressBar.dragStartX = event.clientX;
    progressBar.dragStartValue = audio.currentTime;
    //pausePlayer();
});

// progressBar.addEventListener('mousedown', () => {
//     pausePlayer();
// });

// progressBar.addEventListener('mouseup', () => {
//     resumePlayer();
// });